"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrandDeepLink = exports.getRBIDomain = exports.getBrandDomain = exports.BrandDeepLinkPrefix = exports.BrandDomainMapProd = exports.BrandDomainMapDev = void 0;
const brand_1 = require("./brand");
const domains_1 = require("./generated/domains");
const stage_1 = require("./stage");
__exportStar(require("./generated/domains"), exports);
exports.BrandDomainMapDev = {
    [brand_1.Brand.BK]: 'https://dev.web.bk.rbi.tools/',
    [brand_1.Brand.LTW]: 'https://dev.web.ltw.rbi.tools/',
    [brand_1.Brand.PLK]: 'https://dev.web.plk.rbi.tools/',
    [brand_1.Brand.TH]: 'https://dev.web.th.rbi.tools/',
    [brand_1.Brand.FHS]: 'https://dev.web.fhs.rbi.tools/',
};
exports.BrandDomainMapProd = {
    [brand_1.Brand.BK]: 'https://www.bk.com/',
    [brand_1.Brand.LTW]: '',
    [brand_1.Brand.PLK]: 'https://www.popeyes.com/',
    [brand_1.Brand.TH]: 'https://timhortons.ca/',
    [brand_1.Brand.FHS]: 'https://www.firehousesubs.com/',
};
var BrandDeepLinkPrefix;
(function (BrandDeepLinkPrefix) {
    BrandDeepLinkPrefix["BK"] = "burgerking://";
    BrandDeepLinkPrefix["LTW"] = "ltw://";
    BrandDeepLinkPrefix["PLK"] = "popeyes://";
    BrandDeepLinkPrefix["TH"] = "timhortons://";
    BrandDeepLinkPrefix["FHS"] = "firehousesubs://";
})(BrandDeepLinkPrefix = exports.BrandDeepLinkPrefix || (exports.BrandDeepLinkPrefix = {}));
/**
 * Get the domain for given brand in given environment.
 * @deprecated use getDomain or getRBIDomain instead
 *
 * @param {IGetBrandDomain} options
 * * brand - the brand whose domain is needed.
 * * environment - the environment to look up domain in.
 *
 * @returns {string} The domain for the brand found in the environment lookup.
 */
const getBrandDomain = ({ brand, environment }) => {
    return environment === stage_1.Stage.prod || environment === stage_1.Stage.qa
        ? exports.BrandDomainMapProd[brand]
        : exports.BrandDomainMapDev[brand];
};
exports.getBrandDomain = getBrandDomain;
/**
 * Return the rbi development domain for the configured brand and stage.
 * @param brand
 * @param locale
 */
const getRBIDomain = (brand, stage, locale) => {
    const normalizedLocale = (locale.region || '').toUpperCase();
    const tld = domains_1.localeToTldMap.get(normalizedLocale);
    if (!tld) {
        throw new Error(`Unsupported country code ${normalizedLocale}`);
    }
    return `${stage}-${brand.toLowerCase()}-web.${tld}.rbi.tools`;
};
exports.getRBIDomain = getRBIDomain;
/**
 * Get the deep link prefix for given brand in given environment.
 *
 * @param {IGetDeepLink} options
 * * brand - the brand whose prefix is needed.
 * * stage - the environment to look up prefix in.
 *
 * @returns {string} The prefix for the brand found in the environment lookup.
 */
const getBrandDeepLink = ({ brand }) => {
    return BrandDeepLinkPrefix[brand];
};
exports.getBrandDeepLink = getBrandDeepLink;
//# sourceMappingURL=domains.js.map